import Link from "next/link"
import { useApp } from "@/lib/context"

export default function Footer() {
  const { t } = useApp()

  return (
    <footer className="py-6 px-4 text-center text-muted-foreground text-xs border-t border-border bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="mb-2 text-sm font-semibold text-foreground">Syncmenu</div>
        <Link
          href="https://www.synctech.ao"
          target="_blank"
          rel="noopener noreferrer"
          className="opacity-70 hover:opacity-100 transition-opacity"
        >
          {t("poweredBy")}
        </Link>
      </div>
    </footer>
  )
}